const NO_ACTION = {
    it: 'Nessuna azione: Plancia continua a seguire la spedizione.',
    en: 'No action needed: Plancia keeps following the shipment.',
};
const CATALOGUE = {
    // ── Data on the shipment (blocking; `missing_container` only informs, ADR 0069) ─
    missing_carrier: {
        severity: 'blocking',
        actor: 'data',
        title: { it: 'Manca la compagnia di navigazione', en: 'Shipping line missing' },
        message: {
            it: 'La spedizione non ha una compagnia di navigazione: senza, Plancia non sa a chi chiedere gli aggiornamenti.',
            en: 'The shipment has no shipping line: without it, Plancia does not know whom to ask for updates.',
        },
        action: {
            it: 'Indica la compagnia di navigazione nella spedizione. Il tracking partirà da solo.',
            en: 'Set the shipping line on the shipment. Tracking will start on its own.',
        },
        notifyPeople: false,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: true,
    },
    missing_container: {
        severity: 'info',
        actor: 'data',
        title: { it: 'Manca il numero del container', en: 'Container number missing' },
        message: {
            it: 'La spedizione non ha il numero del container: {carrier} viene seguita con il B/L o il booking. Con il container gli aggiornamenti sono più completi.',
            en: 'The shipment has no container number: {carrier} is followed with the B/L or the booking. With the container the updates are more complete.',
        },
        action: {
            it: 'Aggiungi il numero del container alla spedizione quando lo conosci. Il tracking continua intanto.',
            en: 'Add the container number to the shipment when you know it. Tracking goes on meanwhile.',
        },
        notifyPeople: false,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: true,
    },
    missing_reference: {
        severity: 'blocking',
        actor: 'data',
        title: { it: 'Manca un numero da tracciare', en: 'No number to track' },
        message: {
            it: 'La spedizione non ha né il numero del container, né il B/L, né il booking: senza un numero Plancia non sa cosa cercare sul sito di {carrier}.',
            en: "The shipment has no container number, no B/L and no booking: without a number Plancia does not know what to look for on {carrier}'s site.",
        },
        action: {
            it: 'Aggiungi alla spedizione il numero del container, il B/L o il booking. Il tracking partirà da solo.',
            en: 'Add the container number, the B/L or the booking to the shipment. Tracking will start on its own.',
        },
        notifyPeople: false,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: true,
    },
    invalid_container: {
        severity: 'blocking',
        actor: 'data',
        title: { it: 'Numero del container non valido', en: 'Invalid container number' },
        message: {
            it: "{container} non è un numero di container valido: l'ultima cifra, quella di controllo, dovrebbe essere {expected_digit}. Probabilmente è un errore di battitura.",
            en: '{container} is not a valid container number: the last digit, the check digit, should be {expected_digit}. It is probably a typo.',
        },
        action: {
            it: 'Correggi il numero del container nella spedizione. Il tracking ripartirà da solo.',
            en: 'Fix the container number on the shipment. Tracking will restart on its own.',
        },
        notifyPeople: false,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: true,
    },
    wrong_carrier: {
        severity: 'blocking',
        actor: 'data',
        title: { it: 'Compagnia di navigazione sbagliata', en: 'Wrong shipping line' },
        message: {
            it: 'Il container {container} è di {suggested_carrier}, ma la spedizione è assegnata a {carrier}, e {carrier} non riconosce il numero.',
            en: 'Container {container} belongs to {suggested_carrier}, but the shipment is assigned to {carrier}, and {carrier} does not recognise the number.',
        },
        action: {
            it: 'Controlla la spedizione: se la compagnia è {suggested_carrier}, correggila e il tracking ripartirà da solo.',
            en: 'Check the shipment: if the shipping line is {suggested_carrier}, correct it and tracking will restart on its own.',
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: 10080,
        autoClose: true,
    },
    carrier_not_supported: {
        severity: 'blocking',
        actor: 'support',
        title: { it: 'Compagnia non ancora coperta', en: 'Shipping line not covered yet' },
        message: {
            it: 'Il tracking automatico di Plancia non copre ancora {carrier}.',
            en: "Plancia's automatic tracking does not cover {carrier} yet.",
        },
        action: {
            it: 'Aggiorna il tracking a mano, oppure chiedi a Skemasoft di aggiungere la compagnia.',
            en: 'Update the tracking manually, or ask Skemasoft to add the shipping line.',
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: 1440,
        autoClose: true,
    },
    // ── Data on the shipment (warning / info) ──────────────────────────────
    reference_not_found: {
        severity: 'warning',
        actor: 'data',
        title: { it: 'La compagnia non trova la spedizione', en: 'The shipping line cannot find the shipment' },
        message: {
            it: '{carrier} non trova la spedizione con nessuno dei suoi numeri: {numbers}. Nei primi giorni dopo la prenotazione può succedere; se un numero è sbagliato, non la troverà mai.',
            en: '{carrier} cannot find the shipment with any of its numbers: {numbers}. This can happen in the first days after booking; if a number is wrong, it will never be found.',
        },
        action: {
            it: 'Controlla che i numeri e la compagnia siano giusti. Plancia intanto riprova, sempre più di rado.',
            en: 'Check that the numbers and the shipping line are correct. Meanwhile Plancia keeps retrying, less and less often.',
        },
        notifyPeople: false,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: true,
    },
    prefix_mismatch: {
        severity: 'info',
        actor: 'data',
        title: { it: 'Container di un altro proprietario', en: 'Container owned by someone else' },
        message: {
            it: 'Il prefisso {prefix} del container {container} non è di {carrier} né di una società di noleggio nota.',
            en: 'Prefix {prefix} of container {container} belongs neither to {carrier} nor to a known leasing company.',
        },
        action: {
            it: 'Se il tracking non trova dati, controlla il numero del container e la compagnia.',
            en: 'If tracking finds no data, check the container number and the shipping line.',
        },
        notifyPeople: false,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: true,
    },
    unknown_location: {
        severity: 'info',
        actor: 'data',
        title: { it: 'Porto non riconosciuto', en: 'Port not recognised' },
        message: {
            it: 'Plancia non riconosce il porto «{location}» indicato come {role_it} della spedizione: la mappa e le stime non lo usano finché non è chiaro.',
            en: 'Plancia does not recognise the port "{location}" given as the shipment {role_en}: the map and the estimates do not use it until it is clear.',
        },
        action: {
            it: 'Usa il codice UN/LOCODE del porto nella spedizione, se lo conosci.',
            en: "Use the port's UN/LOCODE on the shipment, if you know it.",
        },
        notifyPeople: false,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: true,
    },
    // TCNU2113866 (21/10/2026): Dokless writes the destination «MOSTAGHANEM» without a UN/LOCODE; Plancia
    // recognises Mostaganem (DZMOS) under the other spelling and says so, info only.
    destination_recognized: {
        severity: 'info',
        actor: 'data',
        title: {
            it: 'Destinazione riconosciuta come {name} ({unlocode})',
            en: 'Destination recognised as {name} ({unlocode})',
        },
        message: {
            it: 'La spedizione indica la destinazione «{written}» senza codice UN/LOCODE: Plancia la riconosce come {name} ({unlocode}), la stessa scritta in un altro modo.',
            en: 'The shipment gives the destination "{written}" without a UN/LOCODE: Plancia recognises it as {name} ({unlocode}), the same name spelled another way.',
        },
        action: {
            it: 'Indica il codice UN/LOCODE {unlocode} nella destinazione e correggi il nome del porto.',
            en: "Give the UN/LOCODE {unlocode} in the destination and correct the port's name.",
        },
        notifyPeople: false,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: true,
    },
    dates_suspicious: {
        severity: 'info',
        actor: 'data',
        title: { it: 'Date della spedizione da controllare', en: 'Shipment dates to check' },
        message: {
            it: 'Le date della spedizione non tornano: partenza {etd}, arrivo {eta}.',
            en: 'The shipment dates do not add up: departure {etd}, arrival {eta}.',
        },
        action: {
            it: 'Controlla ETD ed ETA nella spedizione.',
            en: 'Check the ETD and ETA on the shipment.',
        },
        notifyPeople: false,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: true,
    },
    origin_mismatch: {
        severity: 'warning',
        actor: 'data',
        title: {
            it: 'Partita da un porto diverso da quello della spedizione',
            en: "Departed from a port other than the shipment's",
        },
        message: {
            it: '{carrier} scrive il carico su {vessel} a {carrier_port} il {date}, ma la spedizione parte da {port}. Finché il carico a {port} non risulta, Plancia non segue la nave e non manda la sua posizione.',
            en: '{carrier} reports loading on {vessel} at {carrier_port} on {date}, but the shipment departs from {port}. Until loading at {port} shows up, Plancia does not follow the vessel or send its position.',
        },
        action: {
            it: 'Controlla il porto di partenza sulla spedizione: se è cambiato, correggilo e Plancia riparte da lì.',
            en: 'Check the port of loading on the shipment: if it changed, correct it and Plancia will start again from there.',
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: 10080,
        autoClose: false,
    },
    /* Owner 16/10/2026 (ADR 0030): info for Dokless only, never to people,
       never attention; only the carrier's FINAL port of discharge counts. */
    destination_mismatch: {
        severity: 'info',
        actor: 'data',
        title: {
            it: 'Destinazione diversa da quella della spedizione',
            en: "Destination other than the shipment's",
        },
        message: {
            it: '{carrier} indica come porto di sbarco finale {carrier_port}, ma la spedizione arriva a {port}.',
            en: '{carrier} gives {carrier_port} as the final port of discharge, but the shipment arrives at {port}.',
        },
        action: {
            it: 'Controlla il porto di destinazione sulla spedizione: se è cambiato, correggilo.',
            en: 'Check the port of discharge on the shipment: if it changed, correct it.',
        },
        notifyPeople: false,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: false,
    },
    // ── Departure ───────────────────────────────────────────────────────────
    departure_slipping: {
        severity: 'warning',
        actor: 'none',
        title: { it: 'Partenza prevista in un altro giorno', en: 'Departure expected on another day' },
        message: {
            it: '{carrier} prevede la partenza da {port} il {etd_carrier}{vessel_it}: {days} giorni {direction_it} della data sulla spedizione ({etd_shipment}).',
            en: '{carrier} expects the departure from {port} on {etd_carrier}{vessel_en}: {days} days {direction_en} than the date on the shipment ({etd_shipment}).',
        },
        action: {
            it: "Nessuna azione obbligata: la data di {carrier} è la previsione che conta. Se serve, aggiorna l'ETD della spedizione o avvisa il cliente.",
            en: "No action required: {carrier}'s date is the forecast that counts. If needed, update the shipment ETD or let the customer know.",
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: 1440,
        autoClose: true,
    },
    departure_overdue: {
        severity: 'warning',
        actor: 'manual',
        title: { it: 'Partenza non ancora risultata', en: 'Departure not shown yet' },
        message: {
            it: 'La spedizione doveva partire da {port} il {etd_shipment}: sono passati {days} giorni e {carrier} non mostra né il carico né una nuova data di partenza.',
            en: 'The shipment was due to depart from {port} on {etd_shipment}: {days} days have passed and {carrier} shows neither the loading nor a new departure date.',
        },
        action: {
            it: "Verifica con {carrier} se il container è stato imbarcato o spostato su un'altra nave.",
            en: 'Check with {carrier} whether the container was loaded or moved to another vessel.',
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: 1440,
        autoClose: true,
    },
    vessel_changed: {
        severity: 'info',
        actor: 'none',
        title: { it: 'Cambio di nave nel piano', en: 'Vessel change in the plan' },
        message: {
            it: '{carrier} ha cambiato la nave prevista per la partenza da {port}: prima {from_vessel}, ora {to_vessel}. Di solito vuol dire che il container è stato riprotetto sulla nave successiva.',
            en: '{carrier} changed the vessel planned for the departure from {port}: {from_vessel} before, now {to_vessel}. This usually means the container was rebooked on the next vessel.',
        },
        action: {
            it: 'Controlla il nuovo arrivo previsto e avvisa il destinatario se cambia.',
            en: 'Check the new expected arrival and inform the consignee if it changes.',
        },
        notifyPeople: false,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: true,
    },
    rollover_risk: {
        severity: 'warning',
        actor: 'manual',
        title: { it: 'Rischio rollover', en: 'Rollover risk' },
        message: {
            it: "La nave {vessel} è partita da {port} il {date}, ma {carrier} non ha pubblicato l'imbarco del container {container}. Può essere rimasto a terra (rollover), oppure la compagnia è in ritardo a scriverlo.",
            en: 'Vessel {vessel} left {port} on {date}, but {carrier} has not published the loading of container {container}. It may have been left behind (rolled over), or the carrier is late in publishing it.',
        },
        action: {
            it: 'Verifica con {carrier} se il container è a bordo o riprotetto sulla prossima nave.',
            en: 'Check with {carrier} whether the container is on board or rebooked on the next vessel.',
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: 1440,
        autoClose: true,
    },
    transshipment_missed: {
        severity: 'warning',
        actor: 'manual',
        title: { it: 'Possibile coincidenza persa al trasbordo', en: 'Possible missed transshipment connection' },
        message: {
            it: 'A {port} la nave {vessel} è partita il {date}, ma {carrier} non ha pubblicato il reimbarco del container {container}. Può aver perso la coincidenza.',
            en: 'At {port} vessel {vessel} left on {date}, but {carrier} has not published container {container} being reloaded. It may have missed the connection.',
        },
        action: {
            it: 'Verifica con {carrier} su quale nave prosegue il container e il nuovo arrivo previsto.',
            en: 'Check with {carrier} which vessel the container continues on and the new expected arrival.',
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: 1440,
        autoClose: true,
    },
    // ── Arrival ─────────────────────────────────────────────────────────────
    eta_unreliable: {
        severity: 'warning',
        actor: 'manual',
        title: { it: 'Arrivo previsto non possibile', en: 'Expected arrival not possible' },
        message: {
            it: "{carrier} dà l'arrivo a {port} il {eta}{vessel_it}, ma il container è arrivato a {via} solo il {via_date}. La data non è possibile: con ogni probabilità la coincidenza è persa e il container aspetta un'altra nave.",
            en: '{carrier} gives the arrival at {port} on {eta}{vessel_en}, but the container only reached {via} on {via_date}. The date is not possible: most likely the connection was missed and the container is waiting for another vessel.',
        },
        action: {
            it: 'Chiedi a {carrier} su quale nave e in che data il container lascia {via}.',
            en: 'Ask {carrier} which vessel and on what date the container leaves {via}.',
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: 1440,
        autoClose: true,
    },
    eta_slipping: {
        severity: 'warning',
        actor: 'none',
        title: { it: "L'arrivo previsto continua a slittare", en: 'The expected arrival keeps slipping' },
        message: {
            it: "{carrier} ha spostato l'arrivo previsto a {port} {times} volte: dal {first_date} al {last_date}, {days} giorni più tardi.",
            en: '{carrier} moved the expected arrival at {port} {times} times: from {first_date} to {last_date}, {days} days later.',
        },
        action: {
            it: "Aspettati altri slittamenti: avvisa chi aspetta la merce e non prenotare il ritiro sull'ETA di oggi.",
            en: "Expect further slips: inform whoever is waiting for the goods and do not book the pickup on today's ETA.",
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: 1440,
        autoClose: true,
    },
    eta_divergent: {
        severity: 'warning',
        actor: 'none',
        title: { it: 'La nave arriverà in un altro momento', en: 'The vessel will arrive at a different time' },
        message: {
            it: "{carrier} prevede l'arrivo a {port} il {carrier_eta}. Dalla posizione della nave Plancia stima il {plancia_eta}: {diff_hours} ore di differenza.",
            en: '{carrier} expects the arrival at {port} on {carrier_eta}. From the vessel position Plancia estimates {plancia_eta}: a {diff_hours} hour difference.',
        },
        action: {
            it: "Per organizzare il ritiro considera la stima di Plancia: la posizione della nave è un dato più fresco dell'ETA della compagnia.",
            en: "When arranging the pickup consider Plancia's estimate: the vessel position is fresher than the carrier's ETA.",
        },
        notifyPeople: false,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: true,
    },
    eta_passed: {
        severity: 'warning',
        actor: 'none',
        title: {
            it: "L'arrivo previsto è passato e la nave è ancora lontana",
            en: 'The expected arrival has passed and the vessel is still far away',
        },
        message: {
            it: "{carrier} prevedeva l'arrivo a {port} il {carrier_eta}, {days} giorni fa, ma la nave {vessel} è ancora a {km} km. Il piano della compagnia non è aggiornato.",
            en: "{carrier} expected the arrival at {port} on {carrier_eta}, {days} days ago, but vessel {vessel} is still {km} km away. The carrier's plan is not up to date.",
        },
        action: {
            it: "Non fidarti dell'ETA pubblicato: chiedi a {carrier} il nuovo arrivo previsto.",
            en: 'Do not rely on the published ETA: ask {carrier} for the new expected arrival.',
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: 1440,
        autoClose: true,
    },
    vessel_waiting: {
        severity: 'info',
        actor: 'none',
        title: { it: 'Nave ferma in rada', en: 'Vessel waiting at anchorage' },
        message: {
            it: "La nave {vessel} è ferma a {km} km da {port} da {hours} ore: aspetta un posto in banchina. L'arrivo può slittare.",
            en: 'Vessel {vessel} has been stopped {km} km off {port} for {hours} hours: it is waiting for a berth. The arrival may slip.',
        },
        action: {
            it: "Nessuna azione: Plancia segna l'arrivo appena la nave entra in porto.",
            en: 'No action needed: Plancia records the arrival as soon as the vessel enters the port.',
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: 1440,
        autoClose: true,
    },
    // Dokless, 20/10/2026: with the cargo on board the payload always carries the vessel's position (the last
    // known one with `stale: true` when the AIS has nothing recent); when there is none at all, this says the
    // datum is missing (and that nothing is stuck). Info only, closes when a position arrives.
    position_unavailable: {
        severity: 'info',
        actor: 'data',
        title: { it: 'Posizione della nave non disponibile', en: 'Vessel position not available' },
        message: {
            it: 'Il carico è a bordo della {vessel}, ma Plancia non ha la sua posizione: {why_it}. La rotta e gli eventi restano aggiornati.',
            en: 'The cargo is on board {vessel}, but Plancia has no position for it: {why_en}. The route and the events stay up to date.',
        },
        action: {
            it: 'Nessuna azione: la posizione arriva appena il segnale AIS della nave è disponibile.',
            en: "No action needed: the position comes as soon as the vessel's AIS signal is available.",
        },
        notifyPeople: false,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: true,
    },
    route_changed: {
        severity: 'warning',
        actor: 'none',
        title: { it: 'La nave ha cambiato rotta', en: 'The vessel changed route' },
        message: {
            it: '{vessel} non passa più {from_route_it}: ora va {to_route_it} ({extra_km} km rispetto alla rotta prevista). La rotta sulla mappa è già quella nuova.',
            en: '{vessel} no longer sails {from_route}: it now goes {to_route} ({extra_km} km against the expected route). The map already shows the new route.',
        },
        action: {
            it: "Controlla l'ETA con {carrier}{delay_it}.",
            en: 'Check the ETA with {carrier}{delay_en}.',
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: 1440,
        autoClose: true,
    },
    passage_closed: {
        severity: 'warning',
        actor: 'none',
        title: { it: '{passage_it} chiuso', en: '{passage} closed' },
        message: {
            it: '{passage_it} chiuso dal {date}: la rotta prevista di {vessel} non passa più di lì. {route_it}',
            en: '{passage} closed since {date}: the expected route of {vessel} no longer goes through it. {route_en}',
        },
        action: {
            it: "Controlla l'ETA con {carrier}: la rotta sulla mappa è già quella nuova.",
            en: 'Check the ETA with {carrier}: the map already shows the new route.',
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: 1440,
        autoClose: true,
    },
    passage_reopened: {
        severity: 'info',
        actor: 'none',
        title: { it: '{passage_it} riaperto', en: '{passage} reopened' },
        message: {
            it: '{passage_it} è di nuovo aperto: la rotta di {vessel} può tornare a passarci. {route_it}',
            en: '{passage} is open again: the route of {vessel} can go through it again. {route_en}',
        },
        action: {
            it: "Nessuna azione: Plancia ricalcola rotta ed ETA. Se il viaggio cambia, controlla l'ETA con {carrier}.",
            en: 'No action needed: Plancia recomputes route and ETA. If the voyage changes, check the ETA with {carrier}.',
        },
        notifyPeople: false,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: true,
    },
    passage_restricted: {
        severity: 'info',
        actor: 'none',
        title: { it: '{passage_it}: transito limitato', en: '{passage}: restricted transit' },
        message: {
            it: 'La rotta di {vessel} passa da {passage_it}, dove il transito è limitato dal {date}. {note_it}',
            en: 'The route of {vessel} goes through {passage}, where transit is restricted since {date}. {note_en}',
        },
        action: {
            it: "Nessuna azione: tieni d'occhio l'ETA, il passaggio può portare ritardi.",
            en: 'No action needed: keep an eye on the ETA, the passage may cause delays.',
        },
        notifyPeople: false,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: true,
    },
    vessel_mismatch: {
        severity: 'warning',
        actor: 'data',
        title: { it: 'Posizione incoerente con la partenza', en: 'Position inconsistent with the departure' },
        message: {
            it: "{vessel} risulta partita da {port} il {left_at}, ma il {fix_at} era in un punto che in quel tempo non si raggiunge: {km} km per mare, servirebbero {knots} nodi. La nave o la data di partenza sono sbagliate: Plancia non disegna la rotta e non stima l'arrivo da questa posizione.",
            en: '{vessel} is said to have left {port} on {left_at}, but on {fix_at} it was where it cannot get in that time: {km} km by sea, {knots} knots would be needed. The vessel or the departure date is wrong: Plancia does not draw the route nor estimate the arrival from this position.',
        },
        action: {
            it: 'Controlla con {carrier} la nave e la data di partenza della spedizione.',
            en: "Check the shipment's vessel and departure date with {carrier}.",
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: 1440,
        autoClose: true,
    },
    route_unreliable: {
        severity: 'warning',
        actor: 'none',
        title: { it: 'Rotta non affidabile', en: 'Route not reliable' },
        message: {
            it: 'La rotta calcolata per {origin} → {destination} {reason_it}. Plancia non la disegna e non la manda finché i dati non tornano coerenti.',
            en: 'The route computed for {origin} → {destination} {reason_en}. Plancia does not draw it nor send it until the data are consistent again.',
        },
        action: {
            it: 'Controlla la nave e gli eventi di {carrier}: una posizione o un porto sbagliati spostano la rotta.',
            en: "Check the vessel and {carrier}'s events: a wrong position or port moves the route.",
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: 1440,
        autoClose: true,
    },
    closing_not_at_destination: {
        severity: 'warning',
        actor: 'manual',
        title: { it: 'Chiusura fuori destinazione', en: 'Closing event away from the destination' },
        message: {
            it: '{carrier} scrive «{event_it}» a {place} il {date}, ma la destinazione della spedizione è {destination}. Plancia non la chiude e continua a seguirla.',
            en: "{carrier} writes «{event_en}» at {place} on {date}, but the shipment's destination is {destination}. Plancia does not close it and keeps following it.",
        },
        action: {
            it: 'Controlla con {carrier} dove si trova il container e se è stato consegnato.',
            en: 'Check with {carrier} where the container is and whether it was delivered.',
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: 1440,
        autoClose: true,
    },
    // Two sources disagree (`kind`): the carrier and the AIS signal (`departure`, `arrival`), or two numbers of
    // the same shipment on the same leg (`numbers`, ADR 0068). The texts are the finding's: each kind words its
    // two sides and what Plancia kept.
    data_conflict: {
        severity: 'warning',
        actor: 'data',
        title: { it: '{title_it}', en: '{title_en}' },
        message: {
            it: '{first_says_it} {second_says_it} {kept_it}',
            en: '{first_says_en} {second_says_en} {kept_en}',
        },
        action: { it: '{action_it}', en: '{action_en}' },
        notifyPeople: false,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: true,
    },
    // ── After discharge ─────────────────────────────────────────────────────
    free_time_ending: {
        severity: 'info',
        actor: 'manual',
        title: {
            it: 'Container in porto: franchigia in scadenza',
            en: 'Container at the port: free time running out',
        },
        message: {
            it: 'Il container {container} è stato scaricato a {port} il {discharge_date}, {days} giorni fa, e non risulta ancora ritirato. La franchigia stimata è di {free_days} giorni.',
            en: 'Container {container} was discharged at {port} on {discharge_date}, {days} days ago, and does not appear to have been picked up yet. The estimated free time is {free_days} days.',
        },
        action: {
            it: 'Organizza il ritiro prima che scada la franchigia; i giorni veri sono nel contratto con {carrier}.',
            en: 'Arrange the pickup before the free time expires; the actual days are in the contract with {carrier}.',
        },
        notifyPeople: false,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: true,
    },
    demurrage_risk: {
        severity: 'warning',
        actor: 'manual',
        title: {
            it: 'Container in porto oltre la franchigia stimata',
            en: 'Container at the port beyond the estimated free time',
        },
        message: {
            it: 'Il container {container} è a {port} da {days} giorni (scaricato il {discharge_date}) e non risulta ritirato: la franchigia stimata di {free_days} giorni è superata e possono maturare controstallie.',
            en: 'Container {container} has been at {port} for {days} days (discharged on {discharge_date}) and does not appear to have been picked up: the estimated free time of {free_days} days is over and demurrage may be accruing.',
        },
        action: {
            it: "Verifica il ritiro e i giorni di franchigia con {carrier}; se il ritiro è già avvenuto, aggiungi l'evento a mano.",
            en: 'Check the pickup and the free days with {carrier}; if the pickup already happened, add the event manually.',
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: 1440,
        autoClose: true,
    },
    // ── Tracking lifecycle ──────────────────────────────────────────────────
    container_reused: {
        severity: 'info',
        actor: 'none',
        title: {
            it: "Tracking chiuso: il container viaggia per un'altra spedizione",
            en: 'Tracking closed: the container is travelling for another shipment',
        },
        message: {
            it: "Il container {container} è ripartito il {date} per un'altra spedizione: quello che {carrier} mostra oggi non riguarda più questa. Plancia ha chiuso il tracking e ha tolto i movimenti di quel viaggio.",
            en: 'Container {container} left again on {date} for another shipment: what {carrier} shows today no longer concerns this one. Plancia closed the tracking and removed the movements of that voyage.',
        },
        action: {
            it: 'Se servono, aggiungi a mano gli eventi di questa spedizione.',
            en: 'If needed, add the events of this shipment manually.',
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: false,
    },
    no_data_for_days: {
        severity: 'warning',
        actor: 'manual',
        title: { it: 'Nessun aggiornamento da giorni', en: 'No updates for days' },
        message: {
            it: 'Da {days} giorni Plancia non riceve aggiornamenti da {carrier} per questa spedizione. Il tracking resta attivo e Plancia continua a provare.',
            en: 'For {days} days Plancia has received no updates from {carrier} for this shipment. Tracking stays active and Plancia keeps trying.',
        },
        action: {
            it: 'Se serve il dato adesso, chiedilo a {carrier} e aggiorna il tracking a mano.',
            en: 'If you need the data now, ask {carrier} and update the tracking manually.',
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: 10080,
        autoClose: true,
    },
    tracking_suspended: {
        severity: 'blocking',
        actor: 'manual',
        title: { it: 'Tracking automatico sospeso', en: 'Automatic tracking suspended' },
        message: {
            it: 'Il tracking automatico di questa spedizione è stato sospeso: {reason}',
            en: 'Automatic tracking of this shipment has been suspended: {reason}',
        },
        action: {
            it: 'Aggiorna il tracking a mano. Se vuoi che Plancia riprenda, riattiva il tracking automatico.',
            en: 'Update the tracking manually. If you want Plancia to resume, turn automatic tracking back on.',
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: false,
    },
    reopened: {
        severity: 'info',
        actor: 'none',
        title: { it: 'Tracking riaperto', en: 'Tracking reopened' },
        message: {
            it: 'Plancia ha riaperto il tracking, chiuso per errore: {reason}',
            en: 'Plancia reopened the tracking, which had been closed by mistake: {reason}',
        },
        action: NO_ACTION,
        notifyPeople: true,
        notifyDokless: false,
        silenceMinutes: 10080,
        autoClose: false,
    },
    canceled: {
        severity: 'info',
        actor: 'none',
        title: { it: 'Spedizione annullata dalla compagnia', en: 'Shipment canceled by the shipping line' },
        message: {
            it: '{carrier} indica la spedizione come annullata il {date}. Plancia ha chiuso il tracking.',
            en: '{carrier} shows the shipment as canceled on {date}. Plancia closed the tracking.',
        },
        action: {
            it: 'Se la spedizione è stata riprenotata, aggiorna i numeri nella spedizione.',
            en: 'If the shipment was rebooked, update the numbers on the shipment.',
        },
        notifyPeople: true,
        notifyDokless: true,
        silenceMinutes: null,
        autoClose: false,
    },
    // ── Internal: never sent to Dokless ─────────────────────────────────────
    recipe_broken: {
        internal: true,
        severity: 'warning',
        actor: 'support',
        title: { it: 'Ricetta rotta per {carrier}', en: 'Recipe broken for {carrier}' },
        message: {
            it: 'La ricetta v{version} di {carrier} si è fermata al passo «{step}»: {error}',
            en: 'Recipe v{version} for {carrier} stopped at step "{step}": {error}',
        },
        action: {
            it: 'Fai guardare a Claude, oppure passa la compagnia in modalità modello.',
            en: 'Let Claude look, or switch the carrier to model mode.',
        },
        notifyPeople: true,
        notifyDokless: false,
        silenceMinutes: 60,
        autoClose: true,
    },
    site_down: {
        internal: true,
        severity: 'warning',
        actor: 'none',
        title: { it: 'Sito di {carrier} non raggiungibile', en: '{carrier} site unreachable' },
        message: {
            it: 'Il sito di {carrier} non risponde da {since}. Le letture sono in pausa fino a {cooldown_until}.',
            en: 'The {carrier} site has not answered since {since}. Reads are paused until {cooldown_until}.',
        },
        action: NO_ACTION,
        notifyPeople: true,
        notifyDokless: false,
        silenceMinutes: 360,
        autoClose: true,
    },
    anti_bot: {
        internal: true,
        severity: 'warning',
        actor: 'manual',
        title: { it: 'Blocco anti-bot su {carrier}', en: 'Anti-bot wall on {carrier}' },
        message: {
            it: 'Il sito di {carrier} ha fermato la lettura con un controllo anti-bot. La scheda è aperta in Chrome.',
            en: 'The {carrier} site stopped the read with an anti-bot check. The tab is open in Chrome.',
        },
        action: {
            it: 'Risolvi il controllo in Chrome e premi «Traccia ora».',
            en: 'Solve the check in Chrome and press "Track now".',
        },
        notifyPeople: true,
        notifyDokless: false,
        silenceMinutes: 20,
        autoClose: true,
    },
    captcha: {
        internal: true,
        severity: 'warning',
        actor: 'manual',
        title: { it: 'Captcha su {carrier}', en: 'Captcha on {carrier}' },
        message: {
            it: 'Il sito di {carrier} chiede un captcha. La scheda è aperta in Chrome.',
            en: 'The {carrier} site asks for a captcha. The tab is open in Chrome.',
        },
        action: {
            it: 'Risolvi il captcha in Chrome e premi «Traccia ora».',
            en: 'Solve the captcha in Chrome and press "Track now".',
        },
        notifyPeople: true,
        notifyDokless: false,
        silenceMinutes: 20,
        autoClose: true,
    },
    extension_offline: {
        internal: true,
        severity: 'warning',
        actor: 'support',
        title: { it: 'Estensione non in linea', en: 'Extension offline' },
        message: {
            it: "L'estensione {client} non dà segni di vita dalle {last_seen}: le letture sono ferme.",
            en: 'Extension {client} has not been heard from since {last_seen}: reads are stopped.',
        },
        action: {
            it: 'Controlla che il computer con Chrome sia acceso e Chrome aperto.',
            en: 'Check that the Chrome machine is on and Chrome is open.',
        },
        notifyPeople: true,
        notifyDokless: false,
        silenceMinutes: 30,
        autoClose: true,
    },
    dokless_unreachable: {
        internal: true,
        severity: 'warning',
        actor: 'support',
        title: { it: 'Dokless non raggiungibile', en: 'Dokless unreachable' },
        message: {
            it: 'Dokless non accetta i dati da {since}: {pending} invii in attesa.',
            en: 'Dokless has not accepted data since {since}: {pending} deliveries pending.',
        },
        action: {
            it: 'Plancia riprova ogni ora. Controlla lo stato di Dokless.',
            en: 'Plancia retries every hour. Check the state of Dokless.',
        },
        notifyPeople: true,
        notifyDokless: false,
        silenceMinutes: 30,
        autoClose: true,
    },
    dokless_rejected: {
        internal: true,
        severity: 'warning',
        actor: 'support',
        title: { it: 'Dokless ha rifiutato un invio', en: 'Dokless rejected a delivery' },
        message: {
            it: 'Dokless ha risposto {status} alla revisione {revision}: {error}',
            en: 'Dokless answered {status} to revision {revision}: {error}',
        },
        action: {
            it: 'Guarda la risposta nelle Consegne e correggi prima di reinviare.',
            en: 'Look at the answer under Deliveries and fix it before resending.',
        },
        notifyPeople: true,
        notifyDokless: false,
        silenceMinutes: null,
        autoClose: false,
    },
    dokless_discards_high: {
        internal: true,
        severity: 'warning',
        actor: 'support',
        title: { it: 'Dokless scarta molti campi', en: 'Dokless discards many fields' },
        message: {
            it: "Nell'ultima ora {with_discards} risposte su {answers} di Dokless hanno scarti ({share}): oltre il 20 % il suo interruttore avvisa il titolare di Dokless.",
            en: "In the last hour {with_discards} of Dokless's {answers} answers carried discards ({share}): above 20 % its switch warns Dokless's owner.",
        },
        action: {
            it: 'Guarda gli scarti in «Confronto con Dokless». Per ora Dokless avvisa soltanto e continua ad applicare i campi buoni.',
            en: 'Look at the discards in «Confronto con Dokless». For now Dokless only warns and keeps applying the good fields.',
        },
        notifyPeople: true,
        notifyDokless: false,
        silenceMinutes: 60,
        autoClose: true,
    },
    recipe_proposed: {
        internal: true,
        severity: 'info',
        actor: 'support',
        title: { it: 'Nuova ricetta proposta per {carrier}', en: 'New recipe proposed for {carrier}' },
        message: {
            it: 'Claude propone una ricetta per {carrier} (fiducia {confidence}).',
            en: 'Claude proposes a recipe for {carrier} (confidence {confidence}).',
        },
        action: { it: 'Applica o lascia.', en: 'Apply or leave it.' },
        notifyPeople: true,
        notifyDokless: false,
        silenceMinutes: null,
        autoClose: false,
    },
    recipe_applied: {
        internal: true,
        severity: 'info',
        actor: 'none',
        title: { it: 'Ricetta applicata per {carrier}', en: 'Recipe applied for {carrier}' },
        message: {
            it: 'La ricetta v{version} di {carrier} è attiva.',
            en: 'Recipe v{version} for {carrier} is active.',
        },
        action: NO_ACTION,
        notifyPeople: true,
        notifyDokless: false,
        silenceMinutes: 30,
        autoClose: false,
    },
    repair_failed: {
        internal: true,
        severity: 'warning',
        actor: 'support',
        title: { it: 'Riparazione non riuscita per {carrier}', en: 'Repair failed for {carrier}' },
        message: {
            it: 'Claude non è riuscito a riparare la ricetta di {carrier}: {error}',
            en: 'Claude could not repair the recipe for {carrier}: {error}',
        },
        action: {
            it: 'Passa la compagnia in modalità modello o guarda il sito a mano.',
            en: 'Switch the carrier to model mode or look at the site by hand.',
        },
        notifyPeople: true,
        notifyDokless: false,
        silenceMinutes: 30,
        autoClose: false,
    },
    passages_changed: {
        internal: true,
        severity: 'info',
        actor: 'none',
        title: { it: 'Cambiato lo stato dei passaggi marittimi', en: 'Sea passages changed' },
        message: {
            it: 'Chiusi: {closed}. Riaperti: {reopened}. Limitati: {limited}. Spedizioni interessate: {shipments}.',
            en: 'Closed: {closed}. Reopened: {reopened}. Restricted: {limited}. Shipments affected: {shipments}.',
        },
        action: NO_ACTION,
        notifyPeople: true,
        notifyDokless: false,
        silenceMinutes: 1440,
        autoClose: false,
    },
    vessel_mmsi_conflict: {
        internal: true,
        severity: 'warning',
        actor: 'support',
        title: { it: 'MMSI della nave incerto', en: 'Vessel MMSI uncertain' },
        message: {
            it: "{vessel} (IMO {imo}): Plancia segue l'MMSI {mmsi}, le fonti dicono {found}. Non lo cambio finché non è chiaro.",
            en: '{vessel} (IMO {imo}): Plancia follows MMSI {mmsi}, the sources say {found}. Not switched until it is clear.',
        },
        action: {
            it: "Guarda la nave su MarineTraffic o VesselFinder per IMO e fissa l'MMSI giusto sulla nave.",
            en: 'Look the vessel up by IMO on MarineTraffic or VesselFinder and pin the right MMSI on it.',
        },
        notifyPeople: true,
        notifyDokless: false,
        silenceMinutes: 1440,
        autoClose: false,
    },
    read_incomplete: {
        internal: true,
        severity: 'warning',
        actor: 'support',
        title: { it: 'Lettura incompleta: {reference}', en: 'Incomplete read: {reference}' },
        message: {
            it: 'La pagina di {carrier} per {reference} ha dato {facts} fatti, ma non è tutta la storia del container: {why_it}. Dokless non riceve «events_complete».',
            en: "{carrier}'s page for {reference} gave {facts} facts, but not the container's whole history: {why_en}. Dokless does not get «events_complete».",
        },
        action: {
            it: 'Guarda la lettura e la ricetta di {carrier}: la storia ripiegata va aperta prima della lettura.',
            en: "Look at the read and at {carrier}'s recipe: the folded history must be opened before the scan.",
        },
        notifyPeople: true,
        notifyDokless: false,
        silenceMinutes: 1440,
        autoClose: true,
    },
    recipe_retired: {
        internal: true,
        severity: 'warning',
        actor: 'support',
        title: { it: 'Letture ferme: {carrier}', en: 'Reads held: {carrier}' },
        message: {
            it: '{reference} di {carrier} non viene letta: la ricetta v{version} è stata ritirata ({reason}). Nessuna lettura parte, nemmeno col modello, finché una nuova versione non è approvata. La spedizione resta aperta.',
            en: "{carrier}'s {reference} is not read: recipe v{version} was retired ({reason}). No read leaves, the model's neither, until a new version is approved. The shipment stays open.",
        },
        action: {
            it: 'Prova la versione in bozza di {carrier} (Prova lettura) e attivala se legge bene; intanto aggiorna il tracking a mano se serve.',
            en: "Try {carrier}'s draft version (Test run) and activate it if it reads well; meanwhile update the tracking by hand if needed.",
        },
        notifyPeople: true,
        notifyDokless: false,
        silenceMinutes: 1440,
        autoClose: true,
    },
    budget_warning: {
        internal: true,
        severity: 'warning',
        actor: 'support',
        title: { it: 'Spesa modelli vicina al tetto', en: 'Model spend near the cap' },
        message: {
            it: 'Oggi la spesa per i modelli è {spend_usd} USD su un tetto di {cap_usd} USD.',
            en: 'Model spend today is {spend_usd} USD out of a {cap_usd} USD cap.',
        },
        action: {
            it: 'Controlla le letture ripetute e le riparazioni in corso.',
            en: 'Check repeated reads and running repairs.',
        },
        notifyPeople: true,
        notifyDokless: false,
        silenceMinutes: 1440,
        autoClose: true,
    },
    v1_v2_mismatch: {
        internal: true,
        severity: 'info',
        actor: 'support',
        title: { it: 'v1 e v2 non coincidono', en: 'v1 and v2 disagree' },
        message: {
            it: 'Sulla spedizione {reference} v1 e v2 danno risultati diversi: {fields}.',
            en: 'On shipment {reference} v1 and v2 give different results: {fields}.',
        },
        action: {
            it: 'Guarda il confronto e decidi quale ha ragione.',
            en: 'Look at the comparison and decide which one is right.',
        },
        notifyPeople: false,
        notifyDokless: false,
        silenceMinutes: null,
        autoClose: true,
    },
};
export const ALERT_CATALOGUE = Object.entries(CATALOGUE).map(([code, entry]) => ({
    code,
    internal: entry.internal ?? false,
    ...entry,
}));
const BY_CODE = new Map(ALERT_CATALOGUE.map((definition) => [definition.code, definition]));
export function alertDefinition(code) {
    return BY_CODE.get(code);
}
/**
 * Replaces `{name}` with `params.name`; a missing param renders as «—». An
 * empty param renders as nothing, and the text is trimmed: an optional tail
 * (`passage_restricted`'s `{note_it}`) leaves no dangling space.
 */
export function fillTemplate(template, params) {
    return template.replace(/\{([a-z_]+)\}/g, (_match, name) => params[name] ?? '—').trim();
}
/** Builds the alert object of the payload from a catalogue code and its params. */
export function renderAlert(code, params, options) {
    const definition = BY_CODE.get(code);
    if (!definition)
        throw new Error(`Unknown alert code: ${code}`);
    if (definition.internal)
        throw new Error(`Alert ${code} is internal and never leaves Plancia`);
    const fill = (text) => ({
        it: fillTemplate(text.it, params),
        en: fillTemplate(text.en, params),
    });
    return {
        code,
        severity: options.severity ?? definition.severity,
        actor: definition.actor,
        since: options.since,
        updated_at: options.updatedAt ?? options.since,
        params,
        title: fill(definition.title),
        message: fill(definition.message),
        action: fill(definition.action),
    };
}
//# sourceMappingURL=alerts.js.map